import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';

const SCRIPT_ID = 'cf-turnstile-script';

const TurnstileWidget = forwardRef(({ siteKey, onSuccess, onError, onExpire, action }, ref) => {
    const containerRef = useRef(null);
    const widgetIdRef = useRef(null);

    useImperativeHandle(ref, () => ({
        reset: () => {
            if (widgetIdRef.current !== null && window.turnstile) {
                window.turnstile.reset(widgetIdRef.current);
            }
        },
    }));

    useEffect(() => {
        if (!document.getElementById(SCRIPT_ID)) {
            const script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }

        const renderWidget = () => {
            if (containerRef.current && window.turnstile && widgetIdRef.current === null) {
                widgetIdRef.current = window.turnstile.render(containerRef.current, {
                    sitekey: siteKey,
                    callback: onSuccess,
                    'error-callback': onError,
                    'expired-callback': onExpire,
                    action,
                });
            }
        };

        if (window.turnstile) {
            renderWidget();
        } else {
            const script = document.getElementById(SCRIPT_ID);
            script.addEventListener('load', renderWidget);
            return () => script.removeEventListener('load', renderWidget);
        }

        return () => {
            if (widgetIdRef.current !== null && window.turnstile) {
                window.turnstile.remove(widgetIdRef.current);
                widgetIdRef.current = null;
            }
        };
    }, [siteKey]);

    return <div ref={containerRef} />;
});

TurnstileWidget.displayName = 'TurnstileWidget';
export default TurnstileWidget;
